module.exports = __webpack_public_path__ + "img/iuv-icon.0487971b.png";